import { format, parseISO } from "date-fns";
import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";

import profile_img from "../../../assets/avatar_placeholder.svg";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwDialog, TwPopover, TwRadialProgress } from "../../../components/tailwind";
import { classNames, cutString, getUsedSubscriptionPercentage, pct } from "../../../helpers";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import MigratePurchasesDialog from "./MigratePurchasesDialog";
import PurchaseSessionPopover from "./PurchaseSessionPopover";
import moment from "moment";
import { PlusIcon } from "@heroicons/react/20/solid";
import PurchasesGeneralDialog from "./PurchasesGeneralDialog";
import { billingPeriod } from "../../../utils/constants";
import PurchasesFreeTrial from "./PurchasesFreeTrial";
import { Gift, Repeat, Ticket } from "lucide-react";
import { TwBadge } from "../../../components/tailwind/TwBadge";
import stack_black from "../../../assets/stack.png";
import { ArrowPathIcon, GiftIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline";


export default function PurchasedSessionPass({
    title = "Purchase Details",
    bookingType = "teacherPassPurchaseDetails",
    myMembersDetail = {},
    customerInfo = {},
    customerId,
    classInfo,
    setPassPurchaseList
}) {
    const location = useLocation();
    const [userToken] = useLocalStorage("userToken");
    const userReduxState = useSelector(userState);

    const [listLoading, setListLoading] = React.useState(false);
    const [recentBookingsList, setRecentBookingsList] = React.useState([]);
    const [showViewMore, setShowViewMore] = React.useState(false);
    const [recentBookingsPageNumber, setRecentBookingsPageNumber] = React.useState(1);
    const [bookingFilter, setBookingFilter] = React.useState('all');
    const [openMigrationCreditDialog, setOpenMigrationCreditDialog] = React.useState(false);
    const [openGeneralCreditDialog, setOpenGeneralCreditDialog] = React.useState(false);
    const [allowProductType, setAllowProductType] = React.useState("");
    const [freeCreditPurchasesList, setFreeCreditPurchasesList] = React.useState({
        loading: false,
        dataList: [],
        pageNumber: 1,
        viewMore: false,
    });
    const [classpassPurchasesList, setClasspassPurchasesList] = React.useState({
        loading: false,
        dataList: [],
        pageNumber: 1,
        viewMore: false,
    });
    const [subscriptionsPurchasesList, setSubscriptionsPurchasesList] = React.useState({
        loading: false,
        dataList: [],
        pageNumber: 1,
        viewMore: false,
    });

    const getPurchases = async (page = 1) => {
        setShowViewMore(false);
        setListLoading(true);

        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMyPurchases?page=${page}&filterBy=${bookingFilter}&classId=${classInfo.classId}&businessId=${classInfo.addedByUserId}&passId=${classInfo?.selectedPassDetail?.passId}`,
            url: `${getUrlForBookings()}getMyPurchases?page=${page}&filterBy=${bookingFilter}${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            headers: {
                // "x-access-token": userToken,
            },
        };
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.statusCode === 200 && manageClassesRequest.data.data.data.length) {
                // setPassPurchaseList(manageClassesRequest.data.data)
                if (manageClassesRequest.data.data.total > 10) {
                    setShowViewMore(true);
                }
                if (recentBookingsPageNumber > 1) {
                    setRecentBookingsList([...recentBookingsList, ...manageClassesRequest.data.data.data]);
                } else {
                    setRecentBookingsList(manageClassesRequest.data.data.data);
                }
            }
        }
        setListLoading(false);
    };

    const getFreeCreditPurchases = async (page = 1) => {
        setFreeCreditPurchasesList((prevValues) => ({
            ...prevValues,
            loading: true,
            viewMore: false,
        }));

        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMyPurchases?page=${page}&filterBy=${bookingFilter}${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            url: `${getUrlForBookings()}getMyPurchases?page=${page}&listOf=free${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            headers: {
                // "x-access-token": userToken,
            },
        };
        const apiRequest = await axiosInstance(manageClassesConfig);
        if (apiRequest.status === 200) {
            if (apiRequest.data.statusCode === 200 && apiRequest.data.data.data.length) {
                if (apiRequest.data.data.total > 10) {
                    setFreeCreditPurchasesList((prevValues) => ({
                        ...prevValues,
                        viewMore: true,
                    }));
                }
                if (freeCreditPurchasesList.pageNumber > 1) {
                    setFreeCreditPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: [...recentBookingsList, ...apiRequest.data.data.data],
                    }));
                } else {
                    setFreeCreditPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: apiRequest.data.data.data,
                    }));
                }
            }
        }
        setFreeCreditPurchasesList((prevValues) => ({
            ...prevValues,
            loading: false,
        }));

    };

    const getClasspassPurchases = async (page = 1) => {
        setClasspassPurchasesList((prevValues) => ({
            ...prevValues,
            loading: true,
            viewMore: false,
        }));

        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMyPurchases?page=${page}&filterBy=${bookingFilter}${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            url: `${getUrlForBookings()}getMyPurchases?page=${page}&listOf=classpass${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            headers: {
                // "x-access-token": userToken,
            },
        };
        const apiRequest = await axiosInstance(manageClassesConfig);
        if (apiRequest.status === 200) {
            if (apiRequest.data.statusCode === 200 && apiRequest.data.data.data.length) {
                if (apiRequest.data.data.total > 10) {
                    setClasspassPurchasesList((prevValues) => ({
                        ...prevValues,
                        viewMore: true,
                    }));
                }
                if (classpassPurchasesList.pageNumber > 1) {
                    setClasspassPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: [...recentBookingsList, ...apiRequest.data.data.data],
                    }));
                } else {
                    setClasspassPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: apiRequest.data.data.data,
                    }));
                }
            }
        }
        setClasspassPurchasesList((prevValues) => ({
            ...prevValues,
            loading: false,
        }));

    };

    const getSubscriptionPurchases = async (page = 1) => {
        setSubscriptionsPurchasesList((prevValues) => ({
            ...prevValues,
            loading: true,
            viewMore: false,
        }));

        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMyPurchases?page=${page}&filterBy=${bookingFilter}${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            url: `${getUrlForBookings()}getMyPurchases?page=${page}&listOf=subscription${bookingType === "consumerPurchase" ? `&consumerId=${customerId}` : `&classId=${classInfo.classId}&passId=${classInfo?.selectedPassDetail?.passId}`}&businessId=${userReduxState.userData?.userType == "student" && userReduxState.userData?.myClubs.length > 0 && userReduxState.userData?.myClubs[0] ? userReduxState.userData?.myClubs[0].businessId : userReduxState.userData?._id}`,
            headers: {
                // "x-access-token": userToken,
            },
        };
        const apiRequest = await axiosInstance(manageClassesConfig);
        if (apiRequest.status === 200) {
            if (apiRequest.data.statusCode === 200 && apiRequest.data.data.data.length) {
                if (apiRequest.data.data.total > 10) {
                    setSubscriptionsPurchasesList((prevValues) => ({
                        ...prevValues,
                        viewMore: true,
                    }));
                }
                if (subscriptionsPurchasesList.pageNumber > 1) {
                    setSubscriptionsPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: [...recentBookingsList, ...apiRequest.data.data.data],
                    }));
                } else {
                    setSubscriptionsPurchasesList((prevValues) => ({
                        ...prevValues,
                        dataList: apiRequest.data.data.data,
                    }));
                }
            }
        }
        setSubscriptionsPurchasesList((prevValues) => ({
            ...prevValues,
            loading: false,
        }));

    };

    const reloadProducts = () => {
        // setRecentBookingsPageNumber(1)
        // getPurchases();
        setFreeCreditPurchasesList((prevValues) => ({
            ...prevValues,
            pageNumber: 1,
        }));
        getFreeCreditPurchases();
        setClasspassPurchasesList((prevValues) => ({
            ...prevValues,
            pageNumber: 1,
        }));
        getClasspassPurchases();
        setSubscriptionsPurchasesList((prevValues) => ({
            ...prevValues,
            pageNumber: 1,
        }));
        getSubscriptionPurchases();
    }

    const handleFilterChange = (event) => {
        const { target: { value } } = event;
        setRecentBookingsPageNumber(1)
        setBookingFilter(value);
        setRecentBookingsList([])
    };


    const ticketAmount = (row) => {
        if (row?.amount) {
            return parseFloat(row?.amount || 0).toFixed(2)
        } else {
            return row?.totalStripeAmount > 0 ? parseFloat(parseFloat(row.totalStripeAmount) + parseFloat(row.totalPaymentServiceFee)).toFixed(2) : "0"
        }
    }

    // React.useEffect(() => {
    //     // if (classInfo?.classId) {
    //     if (userReduxState.userData?._id) {
    //         getPurchases(recentBookingsPageNumber);
    //     }
    //     // }, [recentBookingsPageNumber, bookingFilter, classInfo]);
    // }, [recentBookingsPageNumber, bookingFilter, userReduxState.userData?._id, classInfo]);

    React.useEffect(() => {
        if (userReduxState.userData?._id) {
            getFreeCreditPurchases(freeCreditPurchasesList.pageNumber);
        }
    }, [freeCreditPurchasesList.pageNumber, userReduxState.userData?._id, classInfo]);

    React.useEffect(() => {
        if (userReduxState.userData?._id) {
            getClasspassPurchases(classpassPurchasesList.pageNumber);
        }
    }, [classpassPurchasesList.pageNumber, userReduxState.userData?._id, classInfo]);

    React.useEffect(() => {
        if (userReduxState.userData?._id) {
            getSubscriptionPurchases(subscriptionsPurchasesList.pageNumber);
        }
    }, [subscriptionsPurchasesList.pageNumber, userReduxState.userData?._id, classInfo]);


    return (
        <div
            className={`max-w-7xl px-5 py-2 bg-white rounded-2xl  ${bookingType === "teacherPassPurchaseDetails" ? "min-h-[500px] mt-10 pb-10" : ""}`}
        >
            <div className={"flex flex-row justify-between items-center [my-4]"}>
                <div className={"flex flex-col"} style={{ flex: 1 }}>
                    <div className="flex justify-between">
                        <h3 className={"text-black text-lg"}>
                            {/* {title} */}
                        </h3>
                        <div className="flex gap-2 justify-end items-center mb-10">
                            {/* {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<PurchasesFreeTrial
                                recentBookingsList={recentBookingsList}
                                customerInfo={customerInfo}
                                reloadData={() => {
                                    reloadProducts();
                                }} />)} */}
                            {/* {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<TwButton variant={"brown-coffee"} onClick={() => {
                                setOpenMigrationCreditDialog(true)
                            }}>
                                <PlusIcon className="size-5" /> Add Migration Credit
                            </TwButton>)} */}
                            {/* {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<TwButton variant={"orange"} onClick={() => {
                                setOpenGeneralCreditDialog(true)
                            }}>
                                <PlusIcon className="size-5" /> Add Product
                            </TwButton>)} */}

                            {/* {customerInfo?._id && (<TwPopover
                                buttonClassName={"bg-portland-orange text-white rounded-xl w-full p-3"}
                                buttonContent={(<span className={"flex flex-row items-center"}>
                                    <PlusIcon className="size-5" /> Add Credit
                                </span>)}
                            >
                                <div className={"flex flex-col gap-3 py-5"}>
                                    <button
                                        onClick={() => {
                                            setOpenMigrationCreditDialog(true)
                                        }}
                                        className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                                    >
                                        Add Migration Credit
                                    </button>
                                    <button
                                        onClick={() => {
                                            setOpenGeneralCreditDialog(true)
                                        }}
                                        className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                                    >
                                        Add General Credit
                                    </button>
                                </div>
                            </TwPopover>)} */}
                        </div>
                    </div>
                    <p className="text-[10px] text-[#B5B5C3]"></p>
                </div>
            </div>

            <div className={"flex flex-col gap-8 "}>

                <div className={"flex flex-col gap-3 border-2 p-5 border-bright-gray rounded-lg"}>
                    <div className="flex gap-2">
                        <div className="flex-1 flex items-center gap-2">
                            <GiftIcon className="h-4 w-4" />
                            <h4 className="text-base font-semibold">Free Credits</h4>
                            <span className="text-sm text-muted-foreground">({freeCreditPurchasesList.dataList.length})</span>
                        </div>
                        {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<PurchasesFreeTrial
                            btnVariant={"default-box"}
                            recentBookingsList={recentBookingsList}
                            customerInfo={customerInfo}
                            reloadData={() => {
                                reloadProducts();
                            }} />)}
                        {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<TwButton variant={"default-box"} onClick={() => {
                            setOpenMigrationCreditDialog(true)
                        }}>
                            <PlusIcon className="size-5" /> Add Migration Credit
                        </TwButton>)}
                    </div>
                    <div className="overflow-x-auto">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                            <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-10 min-w-52">
                                                Credit
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Status
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Usage
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Added By
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Created
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Valid Until
                                            </th>
                                            {userReduxState.userData?.userType != "student" && (<th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Action
                                            </th>)}
                                            {/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span className="sr-only">Action</span>
                                        </th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {(freeCreditPurchasesList.dataList.length > 0 ? freeCreditPurchasesList.dataList.map((row) => {

                                            return (
                                                <tr key={row._id} className="hover:bg-gray-50 transition-colors">
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 capitalize">
                                                        {row.boughtPassDetails.passName} {row.boughtPassDetails.passName !== "free trial credit" && row?.selectedPassDetail?.isMigratedProduct != undefined && row?.selectedPassDetail?.isMigratedProduct == true ? "(Migration Credit)" : ""}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {row?.selectedPassDetail?.productType == "subscription" ?
                                                            moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Cancelled</TwBadge> : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? (row?.selectedPassDetail.cancelType != undefined && row?.selectedPassDetail.cancelType == "end_of_the_current_period" ? <><TwBadge color="green">Active</TwBadge> <TwBadge color="gray">Cancels ${moment(row.purchaseExpiredDate).format('DD-MMM')}</TwBadge></> : <TwBadge color="gray">Cancelled</TwBadge>) : <TwBadge color="green">Active</TwBadge>)
                                                            :
                                                            row.total_voucher_unused <= 0 ? <TwBadge color="gray">Fully Consumed</TwBadge> : (row?.selectedPassDetail?.validUntilConsumed ? <TwBadge color="green">Active</TwBadge> : moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Expired</TwBadge> : <TwBadge color="green">Active</TwBadge>)

                                                        }
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        <div className="min-w-56 flex items-center gap-3">
                                                            <TwRadialProgress variant="standard" className="size-10" progress={pct(row.total_voucher_used, row.selectedPassDetail.noOfAllowedSessions)} percentageText={pct(row.total_voucher_used, row.selectedPassDetail.noOfAllowedSessions) + "%"} />
                                                            <div className="text-xs leading-5">
                                                                <div>Used {row.total_voucher_used} of {row.selectedPassDetail.noOfAllowedSessions}</div>
                                                                <div className="text-muted-foreground">Left {row.total_voucher_unused}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        <TwBadge color="gray">{row?.productAddedBy && row?.productAddedBy == "business" ? "Club" : "Consumer"}</TwBadge>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {moment(row?.createdAt || row?.purchaseDate).format('DD MMM YYYY')}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {row?.selectedPassDetail?.productType == "subscription" ? (<div className="flex flex-col justify-center">
                                                            <span style={{ fontSize: 14, lineHeight: "14px" }}>{moment(row?.purchaseExpiredDate).format('DD MMM YYYY')}</span>
                                                            <p className="text-sm text-gray-400 max-w-24 [text-wrap] text-center">Auto-renews {billingPeriod.find((f) => f.data.interval == row?.selectedPassDetail?.billingPeriod.interval && f.data.interval_count == row?.selectedPassDetail?.billingPeriod.interval_count).title}</p>

                                                        </div>) : (<div className="flex flex-col justify-center">
                                                            {row?.selectedPassDetail?.validUntilConsumed ? "Until Consumed" : `${moment(row?.purchaseExpiredDate).format('DD MMM YYYY')}`}
                                                        </div>)}
                                                    </td>
                                                    {userReduxState.userData?.userType != "student" && (<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                        {/* {userReduxState.userData?.userType != "student" && (<PurchaseSessionPopover
                                                            purchasingDetails={row}
                                                            customerInfo={customerInfo}
                                                            reloadData={() => {
                                                                reloadProducts();
                                                            }}
                                                        />)} */}
                                                    </td>)}
                                                </tr>
                                            )
                                        }) : listLoading === false && (
                                            <tr>
                                                <td colSpan={7} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    There is no credits
                                                </td>
                                            </tr>
                                        ))}
                                        {listLoading === true ? (
                                            <tr>
                                                <td colSpan={7} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {freeCreditPurchasesList.viewMore ? (<div className={"flex flex-row justify-center my-2"}>
                        <button
                            className={
                                "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                            }
                            onClick={() => {
                                setFreeCreditPurchasesList((prevValues) => ({
                                    ...prevValues,
                                    pageNumber: freeCreditPurchasesList.pageNumber + 1,
                                }));
                            }}
                        >
                            View More
                        </button>
                    </div>) : ""}
                </div>

                <div className={"flex flex-col gap-3 border-2 p-5 border-bright-gray rounded-lg"}>
                    <div className="flex gap-2">
                        <div className="flex-1 flex items-center gap-2">
                            <img className={"size-5"} src={stack_black} alt={""} />
                            <h4 className="text-base font-semibold">Multi-session Passes</h4>
                            <span className="text-sm text-muted-foreground">({classpassPurchasesList.dataList.length})</span>
                        </div>
                        {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<TwButton variant={"default-box"} onClick={() => {
                            setAllowProductType("classpass")
                            setOpenGeneralCreditDialog(true)
                        }}>
                            <PlusIcon className="size-5" /> Add Product
                        </TwButton>)}
                    </div>
                    <div className="overflow-x-auto">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                            <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-10 min-w-52">
                                                Pass Name
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Status
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Usage
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Added By
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Purchased on
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Valid Until
                                            </th>
                                            {userReduxState.userData?.userType != "student" && (<th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Action
                                            </th>)}
                                            {/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span className="sr-only">Action</span>
                                        </th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {(classpassPurchasesList.dataList.length > 0 ? classpassPurchasesList.dataList.map((row) => {

                                            return (
                                                <tr key={row._id} className="hover:bg-gray-50 transition-colors">
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 capitalize">
                                                        {row.boughtPassDetails.passName} {row?.selectedPassDetail?.isMigratedProduct != undefined && row?.selectedPassDetail?.isMigratedProduct == true ? "(Migration Credit)" : ""}
                                                        <p className="text-xs text-gray-400 font-normal text-wrap capitalize">
                                                            €{ticketAmount(row)}
                                                        </p>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {row?.selectedPassDetail?.productType == "subscription" ?
                                                            moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Cancelled</TwBadge> : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? (row?.selectedPassDetail.cancelType != undefined && row?.selectedPassDetail.cancelType == "end_of_the_current_period" ? <><TwBadge color="green">Active</TwBadge> <TwBadge color="gray">Cancels ${moment(row.purchaseExpiredDate).format('DD-MMM')}</TwBadge></> : <TwBadge color="gray">Cancelled</TwBadge>) : <TwBadge color="green">Active</TwBadge>)
                                                            :
                                                            row.status == "Cancelled" ? <TwBadge color="gray">Removed</TwBadge> : (row.total_voucher_unused <= 0 ? <TwBadge color="gray">Fully Consumed</TwBadge> : (row?.selectedPassDetail?.validUntilConsumed ? <TwBadge color="green">Active</TwBadge> : moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Expired</TwBadge> : <TwBadge color="green">Active</TwBadge>))

                                                        }
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        <div className="min-w-56 flex items-center gap-3">
                                                            <TwRadialProgress variant="standard" className="size-10" progress={pct(row.total_voucher_used, row.selectedPassDetail.noOfAllowedSessions)} percentageText={pct(row.total_voucher_used, row.selectedPassDetail.noOfAllowedSessions) + "%"} />
                                                            <div className="text-xs leading-5">
                                                                <div>Used {row.total_voucher_used} of {row.selectedPassDetail.noOfAllowedSessions}</div>
                                                                <div className="text-muted-foreground">Left {row.total_voucher_unused}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        <TwBadge color="gray">{row?.productAddedBy && row?.productAddedBy == "business" ? "Club" : "Consumer"}</TwBadge>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {moment(row?.createdAt || row?.purchaseDate).format('DD MMM YYYY')}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {row?.selectedPassDetail?.productType == "subscription" ? (<div className="flex flex-col justify-center">
                                                            <span style={{ fontSize: 14, lineHeight: "14px" }}>{moment(row?.purchaseExpiredDate).format('DD MMM YYYY')}</span>
                                                            <p className="text-sm text-gray-400 max-w-24 [text-wrap] text-center">Auto-renews {billingPeriod.find((f) => f.data.interval == row?.selectedPassDetail?.billingPeriod.interval && f.data.interval_count == row?.selectedPassDetail?.billingPeriod.interval_count).title}</p>

                                                        </div>) : (<div className="flex flex-col justify-center">
                                                            {row?.selectedPassDetail?.validUntilConsumed ? "Until Consumed" : `${moment(row?.purchaseExpiredDate).format('DD MMM YYYY')}`}
                                                        </div>)}
                                                    </td>
                                                    {userReduxState.userData?.userType != "student" && (<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                        {userReduxState.userData?.userType != "student" && (<PurchaseSessionPopover
                                                            purchasingDetails={row}
                                                            myMembersDetail={myMembersDetail}
                                                            customerInfo={customerInfo}
                                                            reloadData={() => {
                                                                reloadProducts();
                                                            }}
                                                        />)}
                                                    </td>)}
                                                </tr>
                                            )
                                        }) : listLoading === false && (
                                            <tr>
                                                <td colSpan={7} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    There is no Products
                                                </td>
                                            </tr>
                                        ))}
                                        {listLoading === true ? (
                                            <tr>
                                                <td colSpan={7} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {classpassPurchasesList.viewMore ? (<div className={"flex flex-row justify-center my-2"}>
                        <button
                            className={
                                "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                            }
                            onClick={() => {
                                setClasspassPurchasesList((prevValues) => ({
                                    ...prevValues,
                                    pageNumber: classpassPurchasesList.pageNumber + 1,
                                }));
                            }}
                        >
                            View More
                        </button>
                    </div>) : ""}
                </div>

                <div className={"flex flex-col gap-3 border-2 p-5 border-bright-gray rounded-lg"}>
                    <div className="flex gap-2">
                        <div className="flex-1 flex items-center gap-2">
                            <ArrowPathIcon className="h-4 w-4" />
                            <h4 className="text-base font-semibold">Subscriptions</h4>
                            <span className="text-sm text-muted-foreground">({subscriptionsPurchasesList.dataList.length})</span>
                        </div>
                        {userReduxState.userData?.userType == "teacher" && customerInfo?._id && (<TwButton variant={"default-box"} onClick={() => {
                            setAllowProductType("subscription")
                            setOpenGeneralCreditDialog(true)
                        }}>
                            <PlusIcon className="size-5" /> Add Subscription
                        </TwButton>)}
                    </div>
                    <div className="overflow-x-auto">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                            <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-10 min-w-52">
                                                Subscription
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Status
                                            </th>
                                            {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Price
                                            </th> */}
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Added By
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Started
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Next Renewal Date
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Cancelled
                                            </th>
                                            {userReduxState.userData?.userType != "student" && (<th scope="col" className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500">
                                                Action
                                            </th>)}
                                            {/* <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span className="sr-only">Action</span>
                                        </th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {(subscriptionsPurchasesList.dataList.length > 0 ? subscriptionsPurchasesList.dataList.map((row) => {

                                            return (
                                                <tr key={row._id} className="hover:bg-gray-50 transition-colors">
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 capitalize">
                                                        <div className="flex gap-2">
                                                            <TwRadialProgress variant="standard" className="size-5 mt-1" progress={getUsedSubscriptionPercentage(moment(row.purchaseDate).unix(), moment(row.purchaseExpiredDate).unix())} />
                                                            <div className="flex flex-col gap-2">
                                                                {row.boughtPassDetails.passName} {row?.selectedPassDetail?.isMigratedProduct != undefined && row?.selectedPassDetail?.isMigratedProduct == true ? "(Migration Credit)" : ""}
                                                                <p className="text-xs text-gray-400 font-normal text-wrap capitalize">
                                                                    €{ticketAmount(row)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        {row?.selectedPassDetail?.productType == "subscription" ?
                                                            // moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Cancelled</TwBadge> : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? (row?.selectedPassDetail.cancelType != undefined && row?.selectedPassDetail.cancelType == "end_of_the_current_period" ? <><TwBadge color="green">Active</TwBadge> <TwBadge color="gray">Cancels {moment(row.purchaseExpiredDate).format('DD-MMM')}</TwBadge></> : <TwBadge color="gray">Cancelled</TwBadge>) : <TwBadge color="green">Active</TwBadge>)
                                                            moment(row?.purchaseExpiredDate).isBefore(moment()) ? (row?.paymentStatus == "Unpaid" ? <TwBadge color="gray">Unpaid</TwBadge> : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? <TwBadge color="gray">Cancelled</TwBadge> : <TwBadge color="green">Active</TwBadge>)) : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? (row?.selectedPassDetail.cancelType != undefined && row?.selectedPassDetail.cancelType == "end_of_the_current_period" ? <><TwBadge color="green">Active</TwBadge> <TwBadge color="gray">Cancels {moment(row.purchaseExpiredDate).format('DD-MMM')}</TwBadge></> : <TwBadge color="gray">Cancelled</TwBadge>) : <TwBadge color="green">Active</TwBadge>)
                                                            :
                                                            row.total_voucher_unused <= 0 ? <TwBadge color="gray">Fully Consumed</TwBadge> : (row?.selectedPassDetail?.validUntilConsumed ? <TwBadge color="green">Active</TwBadge> : moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Expired</TwBadge> : <TwBadge color="green">Active</TwBadge>)
                                                        }
                                                    </td>
                                                    {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        €{ticketAmount(row)}/{row?.selectedPassDetail?.productType == "subscription" && billingPeriod.find((f) => f.data.interval == row?.selectedPassDetail?.billingPeriod.interval && f.data.interval_count == row?.selectedPassDetail?.billingPeriod.interval_count).value}
                                                    </td> */}
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                        <TwBadge color="gray">{row?.productAddedBy && row?.productAddedBy == "business" ? "Club" : "Consumer"}</TwBadge>
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {moment(row?.purchaseDate).format('DD MMM YYYY')}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {row?.selectedPassDetail?.productType == "subscription" && (row?.selectedPassDetail.isCancel == undefined || row?.selectedPassDetail.isCancel == false) ? moment(row?.purchaseExpiredDate).format('DD MMM YYYY') : <TwBadge color="red">No future renewals</TwBadge>}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                        {row?.selectedPassDetail?.productType == "subscription" && row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? moment(row?.selectedPassDetail?.cancelDate || row?.purchaseExpiredDate).format('DD MMM YYYY') : "---"}
                                                    </td>
                                                    {userReduxState.userData?.userType != "student" && (<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                        {userReduxState.userData?.userType != "student" && (<PurchaseSessionPopover
                                                            purchasingDetails={row}
                                                            customerInfo={customerInfo}
                                                            reloadData={() => {
                                                                reloadProducts();
                                                            }}
                                                        />)}
                                                    </td>)}
                                                </tr>
                                            )
                                        }) : listLoading === false && (
                                            <tr>
                                                <td colSpan={8} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    There is no subscriptions
                                                </td>
                                            </tr>
                                        ))}
                                        {listLoading === true ? (
                                            <tr>
                                                <td colSpan={8} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {subscriptionsPurchasesList.viewMore ? (<div className={"flex flex-row justify-center my-2"}>
                        <button
                            className={
                                "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                            }
                            onClick={() => {
                                setSubscriptionsPurchasesList((prevValues) => ({
                                    ...prevValues,
                                    pageNumber: subscriptionsPurchasesList.pageNumber + 1,
                                }));
                            }}
                        >
                            View More
                        </button>
                    </div>) : ""}
                </div>
            </div>



            <div className="overflow-x-auto mt-5 hidden">
                <table className="min-w-full divide-y divide-gray-300">
                    <thead className="">
                        <tr className="text-center">
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                PRODUCT NAME
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-500 truncate">
                                TYPE
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-500 truncate">
                                CREDIT REMAINING
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-500 truncate">
                                VALID UNTIL
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-500 truncate">
                                STATUS
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-500"></th>
                        </tr>
                    </thead>
                    <tbody className="divide-y-8 !border-y-0 divide-white ">
                        {listLoading ? (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    Loading...
                                </td>
                            </tr>
                        ) : recentBookingsList.length ? recentBookingsList.map((row, i) => (
                            <tr key={i} className="bz-td-row">
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold capitalize">
                                    {row.boughtPassDetails.passName} {row?.selectedPassDetail?.isMigratedProduct != undefined && row?.selectedPassDetail?.isMigratedProduct == true ? "(Migration Credit)" : ""}
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold capitalize">
                                    {row?.selectedPassDetail?.productType == "subscription" ? row?.selectedPassDetail?.productType : "One-time"}
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold">
                                    {/* {row.total_voucher_unused + "/" + row?.selectedPassDetail?.noOfAllowedSessions} */}
                                    {row?.selectedPassDetail?.productType == "subscription" ? "Unlimited" : row.total_voucher_unused}
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold">
                                    {row?.selectedPassDetail?.productType == "subscription" ? (<div className="flex flex-col justify-center items-center">
                                        <span style={{ fontSize: 14, lineHeight: "14px" }}>{moment(row?.purchaseExpiredDate).format('DD-MM-YYYY')}</span>
                                        <p className="text-sm text-gray-400 max-w-24 [text-wrap] text-center">Auto-renews {billingPeriod.find((f) => f.data.interval == row?.selectedPassDetail?.billingPeriod.interval && f.data.interval_count == row?.selectedPassDetail?.billingPeriod.interval_count).title}</p>

                                    </div>) : (<div className="flex flex-col justify-center items-center">
                                        {row?.selectedPassDetail?.validUntilConsumed ? "Until Consumed" : `${moment(row?.purchaseExpiredDate).format('DD-MM-YYYY')}`}
                                    </div>)}

                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold">
                                    {row?.selectedPassDetail?.productType == "subscription" ?
                                        moment(row?.purchaseExpiredDate).isBefore(moment()) ? <TwBadge color="gray">Cancelled</TwBadge> : (row?.selectedPassDetail.isCancel != undefined && row?.selectedPassDetail.isCancel == true ? (row?.selectedPassDetail.cancelType != undefined && row?.selectedPassDetail.cancelType == "end_of_the_current_period" ? <><TwBadge color="green">Active</TwBadge> <TwBadge color="gray">Cancels ${moment(row.purchaseExpiredDate).format('DD-MMM')}</TwBadge></> : <TwBadge color="gray">Cancelled</TwBadge>) : "Active")
                                        :
                                        row.total_voucher_unused <= 0 ? <TwBadge color="gray">Fully Consumed</TwBadge> : (row?.selectedPassDetail?.validUntilConsumed ? "Active" : moment(row?.purchaseExpiredDate).isBefore(moment()) ? "Expired" : "Active")

                                    }
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold rounded-r-2xl">
                                    {userReduxState.userData?.userType != "student" && (<PurchaseSessionPopover
                                        purchasingDetails={row}
                                        customerInfo={customerInfo}
                                        reloadData={() => {
                                            reloadProducts();
                                        }}
                                    />)}
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    There is no Products
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            </div>
            {showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
                <button
                    className={
                        "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                    }
                    onClick={() => {
                        setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
                    }}
                >
                    View More
                </button>
            </div>) : ""}

            <TwDialog
                dialogTitle={"Add Migration credit"}
                dialogOpen={openMigrationCreditDialog}
                isFullContent={true}
                onClose={(v) => { setOpenMigrationCreditDialog(false) }}
            >
                <MigratePurchasesDialog
                    openMigrationCreditDialog={openMigrationCreditDialog}
                    setOpenMigrationCreditDialog={setOpenMigrationCreditDialog}
                    customerInfo={customerInfo}
                    reloadData={() => {
                        reloadProducts();
                    }}
                />
            </TwDialog>

            <PurchasesGeneralDialog
                allowProductType={allowProductType}
                openGeneralCreditDialog={openGeneralCreditDialog}
                setOpenGeneralCreditDialog={setOpenGeneralCreditDialog}
                customerInfo={customerInfo}
                reloadData={() => {
                    reloadProducts();
                }}
            />
        </div>
    );
}
